import { addFormatter } from "aldoo-ra/CMS/field-formatter"
import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import { addDisplayFormatter } from "aldoo-ra/CMS/field-display-format-resolver"
import BundleItemFormatter from "./formatters/store-bundle-formatter"
import BundleItemEditor from "./editors/store-bundle-editor"

// Bundle item configuration type
export const BundleItemType = {
    id: "BundleItem",
    label: "Bundle Item Configuration",
    groups: [
        {
            id: "product",
            label: "Product",
            description: "Select the product to include in the bundle",
            expanded: true,
        },
        {
            id: "quantity",
            label: "Quantity",
            description: "Configure the quantity",
        },
        {
            id: "pricing",
            label: "Pricing",
            description: "Optional price override for this bundle item",
        }
    ],
    fields: [
        {
            id: "product",
            group: "product",
            label: "Product",
            type: "DatabaseModel",
            item: "StoreProduct",
            required: true,
            searchFields: ["pid", "name"],
            overview: "productSearchResult",
            description: "Product to include in the bundle",
            render: { variant: "full" },
        },
        {
            id: "quantity",
            group: "quantity",
            label: "Quantity",
            type: "Number",
            required: true,
            min: 1,
            default: 1,
            description: "Number of units of this product in the bundle",
            render: { variant: "full" },
        },
        {
            id: "price",
            group: "pricing",
            label: "Price Override",
            type: "DatabaseModel",
            item: "StorePrice",
            searchFields: ["price_id"],
            overview: "priceSearchResult",
            description: "Optional price override for this product in the bundle",
            render: { variant: "full" },
        }
    ]
};

// Register formatters and editors
addFormatter("BundleItem", BundleItemFormatter);
addFieldEditor("BundleItemEditor", BundleItemEditor);

//Related to BundleItemType
addDisplayFormatter("productSearchResult", (item) => {
    if (!item) return "No product selected";
    return item.name;
});

// Display formatter for bundle items in search/selection
addDisplayFormatter("BundleItem", (item) => {
    if (!item || !item.product) return "No product selected";

    const quantity = item.quantity > 1 ? ` × ${item.quantity}` : '';
    const priceOverride = item.price ? ' (Custom Price)' : '';

    return `${item.product.name}${quantity}${priceOverride}`;
});

// Note: BundleItem is an embedded type, not a standalone database model
// So it doesn't need RegisterInDBResolver = true